(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanyCustomerDialogController', CompanyCustomerDialogController);

    CompanyCustomerDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CompanyCustomer', 'Company', 'Customer'];

    function CompanyCustomerDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, CompanyCustomer, Company, Customer) {
        var vm = this;

        vm.companyCustomer = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.companies = Company.query();
        vm.customers = Customer.query();

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.companyCustomer.id !== null) {
                CompanyCustomer.update(vm.companyCustomer, onSaveSuccess, onSaveError);
            } else {
                CompanyCustomer.save(vm.companyCustomer, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:companyCustomerUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
